import React from 'react';
import { Select } from '@tesla/informed-tds';
import { getCountries } from '@tesla/region/dist';
import { string } from 'prop-types';

const CountryInput = ({ langCode, emptySelectOption, ...props }) => {
  const allCountries = getCountries(undefined, langCode);

  return (
    <Select {...props}>
      <option key="empty" value="">
        {emptySelectOption}
      </option>
      {allCountries.map((country) => (
        <option key={`countryCode_${country.code}`} value={country.code}>
          {country.label ? country.label : country.code}
        </option>
      ))}
    </Select>
  );
};

CountryInput.propTypes = {
  langCode: string,
  emptySelectOption: string.isRequired,
};

CountryInput.defaultProps = {
  langCode: 'en',
};

export default CountryInput;
